import { render, staticRenderFns } from "./VolunteerActions.vue?vue&type=template&id=1ff76866"
import script from "./VolunteerActions.vue?vue&type=script&lang=ts"
export * from "./VolunteerActions.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerActions.vue?vue&type=style&index=0&id=1ff76866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports